export default __webpack_public_path__ + "static/media/simple_architecture.89c112b4.svg";